/**
 * Custom storefront scripts extracted from layout/theme.liquid and sections/static-header.liquid.
 * Loaded with `defer` before </body>.
 */
(function () {
  'use strict';

  function onDomReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function onWindowLoad(fn) {
    if (document.readyState === 'complete') {
      fn();
    } else {
      window.addEventListener('load', fn);
    }
  }

  /* --- 1. Shopify Global Anti-Bot Honeypot Script --- */
  onDomReady(function () {
    var forms = document.querySelectorAll('form');
    forms.forEach(function (form) {
      var hp = document.createElement('input');
      hp.type = 'text';
      hp.name = 'website';
      hp.style.display = 'none';
      hp.autocomplete = 'off';
      form.appendChild(hp);

      form.dataset.start = Date.now();

      form.addEventListener('submit', function (e) {
        var elapsed = Date.now() - form.dataset.start;
        var hpVal = hp.value.trim();

        if (hpVal !== '' || elapsed < 2000) {
          e.preventDefault();
          console.warn('Spam submission blocked.');
          return false;
        }
      });
    });
  });

  /* --- 2. WhatsApp Button Google Ads Conversion Helper --- */
  window.gtag_report_conversion = function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url !== 'undefined') {
        window.location = url;
      }
    };
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-655655846/MmyvCNv3mrMCEKaH0rgC',
        event_callback: callback,
      });
    } else {
      callback();
    }
    return false;
  };

  /* --- 3. Deferred Third-Party Analytics (Pagesense, Twitter uwt, LinkedIn Insight) --- */
  (function () {
    var loaded = false;
    var events = ['scroll', 'pointerdown', 'keydown', 'touchstart', 'mousemove'];

    function loadDeferredAnalytics() {
      if (loaded) return;
      loaded = true;
      events.forEach(function (evt) {
        window.removeEventListener(evt, loadDeferredAnalytics);
      });

      /* Pagesense */
      var ps = document.createElement('script');
      ps.async = true;
      ps.src = 'https://cdn.pagesense.io/js/829685981/492b107b590544aeac916facafc832fa.js';
      document.head.appendChild(ps);

      /* Twitter conversion tracking (uwt.js) */
      !(function (e, t, n, s, u, a) {
        e.twq ||
          ((s = e.twq =
            function () {
              s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
            }),
          (s.version = '1.1'),
          (s.queue = []),
          (u = t.createElement(n)),
          (u.async = !0),
          (u.src = 'https://static.ads-twitter.com/uwt.js'),
          (a = t.getElementsByTagName(n)[0]),
          a.parentNode.insertBefore(u, a));
      })(window, document, 'script');
      window.twq('config', 'ocng9');

      /* LinkedIn Insight Tag */
      window._linkedin_partner_id = '1912260';
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(window._linkedin_partner_id);
      (function () {
        var s = document.getElementsByTagName('script')[0];
        var b = document.createElement('script');
        b.type = 'text/javascript';
        b.async = true;
        b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        s.parentNode.insertBefore(b, s);
      })();
    }

    events.forEach(function (evt) {
      window.addEventListener(evt, loadDeferredAnalytics, { passive: true, once: true });
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadDeferredAnalytics, { timeout: 5000 });
    } else {
      onWindowLoad(function () {
        setTimeout(loadDeferredAnalytics, 4000);
      });
    }
  })();

  /* --- 4. Cookie Helper & Card Link UTM Attribution --- */
  window.getCookie = function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].trim().split('=');
      var cookieName = parts[0];
      var cookieValue = parts[1];
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  };

  onDomReady(function () {
    var dynamicLinks = Array.from(document.querySelectorAll('.card__link'));
    if (!dynamicLinks.length) return;

    var refer_url = window.location.href;
    var utm_campaign = window.getCookie('utm_campaign');
    var utm_content = window.getCookie('utm_content');
    var utm_source = window.getCookie('utm_source');
    var utm_term = window.getCookie('utm_term');
    var utm_medium = window.getCookie('utm_medium');

    dynamicLinks.forEach(function (link) {
      link.href =
        'https://elmadrasah-frontend.vercel.app/?utm_campaign=' +
        utm_campaign +
        '&utm_content=' +
        utm_content +
        '&utm_source=' +
        utm_source +
        '&utm_term=' +
        utm_term +
        '&utm_medium=' +
        utm_medium +
        '&subject=' +
        link.dataset.subject +
        '&refer_url=' +
        refer_url;
    });
  });

  /* --- 5. Header Scrolled State Toggle --- */
  (function () {
    var section = document.getElementById('shopify-section-static-header');
    if (!section) return;
    var THRESHOLD = 50;
    function onScroll() {
      section.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* --- 6. Dynamic Script Loader & Scroll-Triggered Yandex.Metrika --- */
  window.loadScript = function loadScript(url, attr, attrVal, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    if (callback) {
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        script.onload = function () {
          callback();
        };
      }
    }

    document.body.appendChild(script);
    if (attr && attrVal) {
      var att = document.createAttribute(attr);
      att.value = attrVal;
      script.setAttributeNode(att);
    }
  };

  onWindowLoad(function () {
    window.addEventListener(
      'scroll',
      function () {
        if (window.jQuery) {
          window.jQuery('.spr-summary-actions-newreview').addClass('bttn bttn--secondary');
        }

        // Yandex.Metrika counter
        (function (m, e, t, r, i, k, a) {
          m[i] =
            m[i] ||
            function () {
              (m[i].a = m[i].a || []).push(arguments);
            };
          m[i].l = 1 * new Date();
          ((k = e.createElement(t)),
            (a = e.getElementsByTagName(t)[0]),
            (k.async = 1),
            (k.src = r),
            a.parentNode.insertBefore(k, a));
        })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

        window.ym(56876629, 'init', {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
          ecommerce: 'dataLayer',
        });
      },
      { once: true }
    );
  });

  /* --- 7. jQuery-Dependent UI & Cart Handlers (Guarded for templates without jQuery) --- */
  if (window.jQuery) {
    var $ = window.jQuery;

    $('.dropdown-sec button').click(function () {
      $('.dropdown-sec ul').toggleClass('active');
    });

    $('.modal-cart button.close').on('click', function () {
      $('.modal-cart').fadeOut();
    });

    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      } else {
        $('.modal-approvel').fadeIn();
        $('.modal-approvel button.close').on('click', function () {
          $('.modal-approvel').fadeOut();
        });
        return false;
      }
    });

    $(document).ready(function () {
      $('#headerWTSBtn').click(function () {
        if (window.mixpanel) {
          window.mixpanel.track('Header WTS Chat', { source: window.location.pathname });
        }
      });
      $('#headerCallBtn').click(function () {
        if (window.mixpanel) {
          window.mixpanel.track('Header Phone Call', { source: window.location.pathname });
        }
      });
      $('#DownloadAndroidHeader').click(function () {
        if (window.mixpanel) {
          window.mixpanel.track('Android Download Header', { source: window.location.pathname });
        }
      });
      $('#DownloadIosHeader').click(function () {
        if (window.mixpanel) {
          window.mixpanel.track('ios Download Header', { source: window.location.pathname });
        }
      });
    });

    onWindowLoad(function () {
      $(document).ready(function () {
        $.ajax({
          method: 'GET',
          url: '/cart.js',
        }).complete(function (e) {
          window.cartObject = JSON.parse(e.responseText);
          window.dispatchEvent(new Event('cartObject'));
        });

        $('body').on('click', 'input[id=addittocart]', function () {
          $('.modal-cart').fadeIn();

          if ($(this).hasClass('pending')) return;

          $(this).addClass('pending');
          var $id = $(this).attr('data-id');
          var $quantity = 1;
          var $current = $(this);
          var $productTitle = $(this).attr('data-title');
          var $producPrice = $(this).attr('data-price');
          var image = $current.parent().find('img').attr('srcset');

          $('.modal-cart .product-modal img').attr('src', image);
          $('.modal-cart h2').text($productTitle);
          $('.modal-cart h3 span').text($producPrice / 100);

          $.fn.digits = function () {
            return this.each(function () {
              $(this).text(
                $(this)
                  .text()
                  .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
              );
            });
          };
          $('.modal-cart h3 span').each(function () {
            $(this).digits();
          });

          if (window.cartObject && window.cartObject.items) {
            for (var i = 0; i < window.cartObject.items.length; i++) {
              var item = window.cartObject.items[i];
              if (item.variant_id == $id) {
                $quantity = item.quantity;
                window.cartObject.items[i].quantity = $quantity + 1;
                $productTitle = item.product_title;
                $producPrice = item.price;
              }
            }
          }

          $.ajax({
            method: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: $quantity,
              id: $id,
            },
          }).complete(function () {
            var txt = $current.attr('value');
            $current.addClass('added');
            $current.attr('value', 'Added ✓');
            setTimeout(function () {
              $current.attr('value', txt);
              $current.removeClass('added');
              $current.removeClass('pending');
            }, 2000);
            if (window.cartObject) {
              window.cartObject.item_count += 1;
              $('.quick-cart__indicator').text(window.cartObject.item_count);
            }
          });
        });

        $('.bubbleME').each(function () {
          $(this).on('click', function () {
            var category = $(this).find('h4').text();
            var $target = $("section[data-ref='" + category + "']");
            if ($target.length) {
              $([document.documentElement, document.body]).animate(
                {
                  scrollTop: $target.offset().top - 60,
                },
                1500
              );
            }
          });
        });
      });
    });
  }
})();
